import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireMain } from "C:\\Users\\tbone\\chalkbeat\\chi-election-landing-page-2026\\src\\js\\main.js";
var mainExports = requireMain();
export { mainExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(mainExports);